// extracted by mini-css-extract-plugin
export default {"badge":"DepartmentBadge_badge__dVdkw","compact":"DepartmentBadge_compact__X4ATq","dot":"DepartmentBadge_dot__TQIPx","label":"DepartmentBadge_label__5gJZV"};